import React from 'react';
import { Hero } from '../components/Hero';
import { LocalTrust } from '../components/LocalTrust';
import { Services } from '../components/Services';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { Reviews } from '../components/Reviews';
export function Home() {
  return <main data-id="element-1489">
      <Hero data-id="element-1490" />
      <LocalTrust data-id="element-1491" />
      <Services data-id="element-1492" />
      <HowItWorks data-id="element-1493" />
      <FAQ data-id="element-1494" />
      <Reviews data-id="element-1495" />
    </main>;
}